import { defineComponent as F, ref as v, watchEffect as W, toRef as U, computed as m, watch as O, onMounted as Z, onUnmounted as J, nextTick as Q } from "vue";
import { n as p, D as X } from "./DialogBase-2d1c3e06.mjs";
import { FileType as $, formatFileSize as Y, davGetClient as ee, davRootPath as z, davResultToNode as P, davGetFavoritesReport as te, davGetRecentSearch as ie, davGetDefaultPropfind as ne } from "@nextcloud/files";
import { getCanonicalLocale as D } from "@nextcloud/l10n";
import { NcCheckboxRadioSwitch as j, NcButton as G, NcActions as le, NcActionInput as se, NcBreadcrumbs as re, NcBreadcrumb as ae, NcSelect as oe, NcTextField as ce, NcEmptyContent as ue } from "@nextcloud/vue";
import { join as q } from "path";
import { t as d } from "./index-69148435.mjs";
import { generateUrl as de, generateRemoteUrl as _e } from "@nextcloud/router";
import { toValue as E } from "@vueuse/core";
import { Fragment as fe } from "vue-frag";
import { i as pe } from "./toast-c61fd8a5.mjs";
const me = {
  name: "FileIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
var ve = function() {
  var e = this, t = e._self._c;
  return t("span", e._b({ staticClass: "material-design-icon file-icon", attrs: { "aria-hidden": !e.title, "aria-label": e.title, role: "img" }, on: { click: function(i) {
    return e.$emit("click", i);
  } } }, "span", e.$attrs, !1), [t("svg", { staticClass: "material-design-icon__svg", attrs: { fill: e.fillColor, width: e.size, height: e.size, viewBox: "0 0 24 24" } }, [t("path", { attrs: { d: "M13,9V3.5L18.5,9M6,2C4.89,2 4,2.89 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2H6Z" } }, [e.title ? t("title", [e._v(e._s(e.title))]) : e._e()])])]);
}, he = [], ge = /* @__PURE__ */ p(
  me,
  ve,
  he,
  !1,
  null,
  null,
  null,
  null
);
const K = ge.exports, ye = {
  name: "MenuUpIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
var we = function() {
  var e = this, t = e._self._c;
  return t("span", e._b({ staticClass: "material-design-icon menu-up-icon", attrs: { "aria-hidden": !e.title, "aria-label": e.title, role: "img" }, on: { click: function(i) {
    return e.$emit("click", i);
  } } }, "span", e.$attrs, !1), [t("svg", { staticClass: "material-design-icon__svg", attrs: { fill: e.fillColor, width: e.size, height: e.size, viewBox: "0 0 24 24" } }, [t("path", { attrs: { d: "M7,15L12,10L17,15H7Z" } }, [e.title ? t("title", [e._v(e._s(e.title))]) : e._e()])])]);
}, ke = [], Ce = /* @__PURE__ */ p(
  ye,
  we,
  ke,
  !1,
  null,
  null,
  null,
  null
);
const be = Ce.exports, Fe = {
  name: "MenuDownIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
var Se = function() {
  var e = this, t = e._self._c;
  return t("span", e._b({ staticClass: "material-design-icon menu-down-icon", attrs: { "aria-hidden": !e.title, "aria-label": e.title, role: "img" }, on: { click: function(i) {
    return e.$emit("click", i);
  } } }, "span", e.$attrs, !1), [t("svg", { staticClass: "material-design-icon__svg", attrs: { fill: e.fillColor, width: e.size, height: e.size, viewBox: "0 0 24 24" } }, [t("path", { attrs: { d: "M7,10L12,15L17,10H7Z" } }, [e.title ? t("title", [e._v(e._s(e.title))]) : e._e()])])]);
}, $e = [], xe = /* @__PURE__ */ p(
  Fe,
  Se,
  $e,
  !1,
  null,
  null,
  null,
  null
);
const Ne = xe.exports, Le = {
  "file-picker__file-icon": "_file-picker__file-icon_1vgv4_5"
}, Pe = /* @__PURE__ */ F({
  __name: "LoadingTableRow",
  props: {
    showCheckbox: { type: Boolean }
  },
  setup(l) {
    return { __sfc: !0, fileListIconStyles: Le };
  }
});
var ze = function() {
  var e = this, t = e._self._c, i = e._self._setupProxy;
  return t("tr", { staticClass: "file-picker__row loading-row", attrs: { "aria-hidden": "true" } }, [e.showCheckbox ? t("td", { staticClass: "row-checkbox" }, [t("span")]) : e._e(), t("td", { staticClass: "row-name" }, [t("div", { staticClass: "row-wrapper" }, [t("span", { class: i.fileListIconStyles["file-picker__file-icon"] }), t("span")])]), e._m(0), e._m(1)]);
}, Be = [function() {
  var l = this, e = l._self._c;
  return l._self._setupProxy, e("td", { staticClass: "row-size" }, [e("span")]);
}, function() {
  var l = this, e = l._self._c;
  return l._self._setupProxy, e("td", { staticClass: "row-modified" }, [e("span")]);
}], Ie = /* @__PURE__ */ p(
  Pe,
  ze,
  Be,
  !1,
  null,
  "6aded0d9",
  null,
  null
);
const Re = Ie.exports;
/**
 * @copyright Copyright (c) 2023 Ferdinand Thiessen <opensource@fthiessen.de>
 *
 * @author Ferdinand Thiessen <opensource@fthiessen.de>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 */
function Me(l, e = {}) {
  var t;
  e = { size: 32, cropPreview: !1, mimeFallback: !0, ...e };
  try {
    const i = ((t = l.attributes) == null ? void 0 : t.previewUrl) || de("/core/preview?fileId={fileid}", {
      fileid: l.fileid
    });
    let n;
    try {
      n = new URL(i);
    } catch {
      n = new URL(i, window.location.origin);
    }
    return n.searchParams.set("x", "".concat(e.size)), n.searchParams.set("y", "".concat(e.size)), n.searchParams.set("mimeFallback", "".concat(e.mimeFallback)), n.searchParams.set("c", "".concat(l.attributes.etag)), n.searchParams.set("a", e.cropPreview === !0 ? "0" : "1"), n;
  } catch {
    return null;
  }
}
const De = (l, e) => {
  const t = v(null);
  return W(() => {
    t.value = Me(E(l), E(e || {}));
  }), {
    previewURL: t
  };
}, Ve = {
  name: "FolderIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
var Te = function() {
  var e = this, t = e._self._c;
  return t("span", e._b({ staticClass: "material-design-icon folder-icon", attrs: { "aria-hidden": !e.title, "aria-label": e.title, role: "img" }, on: { click: function(i) {
    return e.$emit("click", i);
  } } }, "span", e.$attrs, !1), [t("svg", { staticClass: "material-design-icon__svg", attrs: { fill: e.fillColor, width: e.size, height: e.size, viewBox: "0 0 24 24" } }, [t("path", { attrs: { d: "M10,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V8C22,6.89 21.1,6 20,6H12L10,4Z" } }, [e.title ? t("title", [e._v(e._s(e.title))]) : e._e()])])]);
}, He = [], Ae = /* @__PURE__ */ p(
  Ve,
  Te,
  He,
  !1,
  null,
  null,
  null,
  null
);
const V = Ae.exports, Ee = /* @__PURE__ */ F({
  __name: "FilePreview",
  props: {
    node: null
  },
  setup(l) {
    const e = l, { previewURL: t } = De(U(e, "node")), i = m(() => e.node.type === $.File), n = v(!1);
    return O(t, () => {
      if (n.value = !1, t.value) {
        const s = document.createElement("img");
        s.src = t.value.href, s.onerror = () => s.remove(), s.onload = () => {
          n.value = !0, s.remove();
        }, document.body.appendChild(s);
      }
    }, { immediate: !0 }), { __sfc: !0, props: e, previewURL: t, isFile: i, canLoadPreview: n, t: d, IconFile: K, IconFolder: V };
  }
});
var Ue = function() {
  var e = this, t = e._self._c, i = e._self._setupProxy;
  return t("div", { staticClass: "file-picker__file-icon", style: i.canLoadPreview ? { backgroundImage: "url(".concat(i.previewURL, ")") } : void 0, attrs: { "aria-label": i.t("MIME type {mime}", { mime: e.node.mime || i.t("unknown") }) } }, [i.canLoadPreview ? e._e() : [i.isFile ? t(i.IconFile, { attrs: { size: 20 } }) : t(i.IconFolder, { attrs: { size: 20 } })]], 2);
}, Oe = [], Ze = /* @__PURE__ */ p(
  Ee,
  Ue,
  Oe,
  !1,
  null,
  "79e0cce3",
  null,
  null
);
const je = Ze.exports, Ge = {
  long: d("a few seconds ago"),
  short: d("seconds ago"),
  // FOR TRANSLATORS: Shorter version of 'a few seconds ago'
  narrow: d("sec. ago")
  // FOR TRANSLATORS: If possible in your language an even shorter version of 'a few seconds ago'
}, qe = F({
  name: "NcDatetime",
  props: {
    /**
     * The timestamp to display, either an unix timestamp (in milliseconds) or a Date object
     */
    timestamp: {
      type: [Date, Number],
      required: !0
    },
    /**
     * The format used for displaying, or if relative time is used the format used for the title (optional)
     *
     * @type {Intl.DateTimeFormatOptions}
     */
    format: {
      type: Object,
      default: () => ({ timeStyle: "medium", dateStyle: "short" })
    },
    /**
     * Wether to display the timestamp as time from now (optional)
     *
     * - `false`: Disable relative time
     * - `'long'`: Long text, like *2 seconds ago* (default)
     * - `'short'`: Short text, like *2 sec. ago*
     * - `'narrow'`: Even shorter text (same as `'short'` on some languages)
     */
    relativeTime: {
      type: [Boolean, String],
      default: "long",
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      validator: (l) => l === !1 || ["long", "short", "narrow"].includes(l)
    },
    /**
     * Ignore seconds when displaying the relative time and just show `a few seconds ago`
     */
    ignoreSeconds: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      /** Current time in ms */
      currentTime: Date.now(),
      /** ID of the current time interval */
      intervalId: void 0
    };
  },
  computed: {
    /** ECMA Date object of the timestamp */
    dateObject() {
      return new Date(this.timestamp);
    },
    /** Time string formatted for main text */
    formattedTime() {
      if (this.relativeTime !== !1) {
        const l = new Intl.RelativeTimeFormat(D(), { numeric: "auto", style: this.relativeTime }), t = (this.dateObject.valueOf() - this.currentTime) / 1e3;
        if (Math.abs(t) <= 90)
          return this.ignoreSeconds ? Ge[this.relativeTime] : l.format(Math.round(t), "second");
        const i = t / 60;
        if (Math.abs(i) <= 90)
          return l.format(Math.round(i), "minute");
        const n = i / 60;
        if (Math.abs(n) <= 72)
          return l.format(Math.round(n), "hour");
        const s = n / 24;
        if (Math.abs(s) <= 6)
          return l.format(Math.round(s), "day");
        const c = s / 7;
        return Math.abs(c) <= 52 ? l.format(Math.round(c), "week") : l.format(Math.round(s / 365), "year");
      }
      return this.formattedFullTime;
    },
    formattedFullTime() {
      return new Intl.DateTimeFormat(D(), this.format).format(this.dateObject);
    }
  },
  watch: {
    /**
     * Set or clear interval if relative time is dis/enabled
     *
     * @param {boolean} newValue The new value of the relativeTime property
     */
    relativeTime(l) {
      window.clearInterval(this.intervalId), this.intervalId = void 0, l && (this.intervalId = window.setInterval(this.setCurrentTime, 1e3));
    }
  },
  mounted() {
    this.relativeTime !== !1 && (this.intervalId = window.setInterval(this.setCurrentTime, 1e3));
  },
  destroyed() {
    window.clearInterval(this.intervalId);
  },
  methods: {
    /**
     * Set `currentTime` to the current timestamp, required as Date.now() is not reactive.
     */
    setCurrentTime() {
      this.currentTime = Date.now();
    }
  }
});
var Ke = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("span", { staticClass: "nc-datetime", attrs: { "data-timestamp": e.timestamp, title: e.formattedFullTime } }, [e._v(e._s(e.formattedTime))]);
}, We = [], Je = /* @__PURE__ */ p(
  qe,
  Ke,
  We,
  !1,
  null,
  null,
  null,
  null
);
const Qe = Je.exports, Xe = /* @__PURE__ */ F({
  __name: "FileListRow",
  props: {
    allowPickDirectory: { type: Boolean },
    selected: { type: Boolean },
    showCheckbox: { type: Boolean },
    canPick: { type: Boolean },
    node: null
  },
  emits: ["update:selected", "enter-directory"],
  setup(l, { emit: e }) {
    const t = l, i = m(() => {
      var _;
      return ((_ = t.node.attributes) == null ? void 0 : _.displayName) || t.node.basename.slice(0, t.node.extension ? -t.node.extension.length : void 0);
    }), n = m(() => t.node.extension), s = m(() => t.node.type === $.Folder), c = m(() => t.canPick && (t.allowPickDirectory || !s.value));
    function u() {
      e("update:selected", !t.selected);
    }
    function a() {
      s.value ? e("enter-directory", t.node) : u();
    }
    function h(_) {
      _.key === "Enter" && a();
    }
    return { __sfc: !0, props: t, emit: e, displayName: i, fileExtension: n, isDirectory: s, isPickable: c, toggleSelected: u, handleClick: a, handleKeyDown: h, formatFileSize: Y, NcCheckboxRadioSwitch: j, t: d, FilePreview: je, NcDatetime: Qe };
  }
});
var Ye = function() {
  var e = this, t = e._self._c, i = e._self._setupProxy;
  return t("tr", e._g(
    { class: ["file-picker__row", {
      "file-picker__row--selected": e.selected && !e.showCheckbox
    }], attrs: { tabindex: e.showCheckbox && !i.isDirectory ? void 0 : 0, "aria-selected": i.isPickable ? e.selected : void 0, "data-filename": e.node.basename, "data-testid": "file-list-row" }, on: { click: i.handleClick } },
    /* same as tabindex -> if we hide the checkbox or this is a directory we need keyboard access to enter the directory or select the node */
    !e.showCheckbox || i.isDirectory ? { keydown: i.handleKeyDown } : {}
  ), [e.showCheckbox ? t("td", { staticClass: "row-checkbox" }, [t(i.NcCheckboxRadioSwitch, { attrs: { disabled: !i.isPickable, checked: e.selected, "aria-label": i.t("Select the row for {nodename}", { nodename: i.displayName }), "data-testid": "row-checkbox" }, on: { click: function(n) {
    n.stopPropagation();
  }, "update:checked": i.toggleSelected } })], 1) : e._e(), t("td", { staticClass: "row-name" }, [t("div", { staticClass: "file-picker__name-container", attrs: { "data-testid": "row-name" } }, [t(i.FilePreview, { attrs: { node: e.node } }), t("div", { staticClass: "file-picker__file-name", attrs: { title: i.displayName }, domProps: { textContent: e._s(i.displayName) } }), t("div", { staticClass: "file-picker__file-extension", domProps: { textContent: e._s(i.fileExtension) } })], 1)]), t("td", { staticClass: "row-size" }, [e._v(" " + e._s(i.formatFileSize(e.node.size || 0)) + " ")]), t("td", { staticClass: "row-modified" }, [e.node.mtime ? t(i.NcDatetime, { attrs: { timestamp: e.node.mtime, "ignore-seconds": !0 } }) : t("span", [e._v(e._s(i.t("Unset")))])], 1)]);
}, et = [], tt = /* @__PURE__ */ p(
  Xe,
  Ye,
  et,
  !1,
  null,
  "41f19c11",
  null,
  null
);
const it = tt.exports, nt = /* @__PURE__ */ F({
  __name: "FileList",
  props: {
    multiselect: { type: Boolean },
    allowPickDirectory: { type: Boolean },
    loading: { type: Boolean },
    files: null,
    selectedFiles: null,
    path: null
  },
  emits: ["update:path", "update:selectedFiles"],
  setup(l, { emit: e }) {
    const t = l, i = v("ascending"), n = v(void 0), s = v(void 0), c = {
      ascending: (r, o, g) => g(r, o),
      descending: (r, o, g) => g(o, r),
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      none: (r, o, g) => 0
    }, u = (r, o) => {
      var g, b;
      return (((g = r.attributes) == null ? void 0 : g.displayName) || r.basename).localeCompare(((b = o.attributes) == null ? void 0 : b.displayName) || o.basename, D());
    }, a = (r, o) => (o.size || 0) - (r.size || 0), h = (r, o) => {
      var g, b;
      return (((g = r.mtime) == null ? void 0 : g.getTime()) || 0) - (((b = o.mtime) == null ? void 0 : b.getTime()) || 0);
    }, _ = (r) => {
      const o = r.value;
      s.value = n.value = i.value = void 0, o === "ascending" ? r.value = "descending" : r.value = "ascending";
    }, k = () => _(i), y = () => _(n), S = () => _(s), w = m(() => [...t.files].sort(
      (r, o) => (
        // Folders always come above the files
        (o.type === $.Folder ? 1 : 0) - (r.type === $.Folder ? 1 : 0) || c[i.value || "none"](r, o, u) || c[n.value || "none"](r, o, a) || c[s.value || "none"](r, o, h)
      )
    )), C = m(() => t.files.filter((r) => t.allowPickDirectory || r.type !== $.Folder)), x = m(() => !t.loading && t.selectedFiles.length > 0 && t.selectedFiles.length >= C.value.length);
    function N() {
      t.selectedFiles.length < C.value.length ? e("update:selectedFiles", C.value) : e("update:selectedFiles", []);
    }
    function B(r) {
      t.selectedFiles.includes(r) ? e("update:selectedFiles", t.selectedFiles.filter((o) => o.path !== r.path)) : t.multiselect ? e("update:selectedFiles", [...t.selectedFiles, r]) : e("update:selectedFiles", [r]);
    }
    function I(r) {
      e("update:path", q(t.path, r.basename));
    }
    const R = v(4), f = v();
    {
      const r = () => Q(() => {
        var o, g, b, T, H;
        const M = ((g = (o = f.value) == null ? void 0 : o.parentElement) == null ? void 0 : g.children) || [];
        let A = ((T = (b = f.value) == null ? void 0 : b.parentElement) == null ? void 0 : T.clientHeight) || 450;
        for (let L = 0; L < M.length; L++)
          (H = f.value) != null && H.isSameNode(M[L]) || (A -= M[L].clientHeight);
        R.value = Math.floor((A - 50) / 50);
      });
      Z(() => {
        window.addEventListener("resize", r), r();
      }), J(() => {
        window.removeEventListener("resize", r);
      });
    }
    return { __sfc: !0, props: t, emit: e, sortByName: i, sortBySize: n, sortByModified: s, ordering: c, byName: u, bySize: a, byDate: h, toggleSorting: _, toggleSortByName: k, toggleSortBySize: y, toggleSortByModified: S, sortedFiles: w, selectableFiles: C, allSelected: x, onSelectAll: N, onNodeSelected: B, onChangeDirectory: I, skeletonNumber: R, fileContainer: f, NcButton: G, NcCheckboxRadioSwitch: j, t: d, IconSortAscending: be, IconSortDescending: Ne, LoadingTableRow: Re, FileListRow: it };
  }
});
var lt = function() {
  var e = this, t = e._self._c, i = e._self._setupProxy;
  return t("div", { ref: "fileContainer", staticClass: "file-picker__files" }, [t("table", [t("thead", [t("tr", [e.multiselect ? t("th", { staticClass: "row-checkbox" }, [t("span", { staticClass: "hidden-visually" }, [e._v(" " + e._s(i.t("Select entry")) + " ")]), e.multiselect ? t(i.NcCheckboxRadioSwitch, { attrs: { "aria-label": i.t("Select all entries"), checked: i.allSelected, "data-testid": "select-all-checkbox" }, on: { "update:checked": i.onSelectAll } }) : e._e()], 1) : e._e(), t("th", { staticClass: "row-name", attrs: { "aria-sort": i.sortByName } }, [t("div", { staticClass: "header-wrapper" }, [t("span", { staticClass: "file-picker__header-preview" }), t(i.NcButton, { attrs: { wide: !0, type: "tertiary", "data-test": "file-picker_sort-name" }, on: { click: i.toggleSortByName }, scopedSlots: e._u([{ key: "icon", fn: function() {
    return [i.sortByName === "ascending" ? t(i.IconSortAscending, { attrs: { size: 20 } }) : i.sortByName === "descending" ? t(i.IconSortDescending, { attrs: { size: 20 } }) : t("span", { staticStyle: { width: "44px" } })];
  }, proxy: !0 }]) }, [e._v(" " + e._s(i.t("Name")) + " ")])], 1)]), t("th", { staticClass: "row-size", attrs: { "aria-sort": i.sortBySize } }, [t(i.NcButton, { attrs: { wide: !0, type: "tertiary" }, on: { click: i.toggleSortBySize }, scopedSlots: e._u([{ key: "icon", fn: function() {
    return [i.sortBySize === "ascending" ? t(i.IconSortAscending, { attrs: { size: 20 } }) : i.sortBySize === "descending" ? t(i.IconSortDescending, { attrs: { size: 20 } }) : t("span", { staticStyle: { width: "44px" } })];
  }, proxy: !0 }]) }, [e._v(" " + e._s(i.t("Size")) + " ")])], 1), t("th", { staticClass: "row-modified", attrs: { "aria-sort": i.sortByModified } }, [t(i.NcButton, { attrs: { wide: !0, type: "tertiary" }, on: { click: i.toggleSortByModified }, scopedSlots: e._u([{ key: "icon", fn: function() {
    return [i.sortByModified === "ascending" ? t(i.IconSortAscending, { attrs: { size: 20 } }) : i.sortByModified === "descending" ? t(i.IconSortDescending, { attrs: { size: 20 } }) : t("span", { staticStyle: { width: "44px" } })];
  }, proxy: !0 }]) }, [e._v(" " + e._s(i.t("Modified")) + " ")])], 1)])]), t("tbody", [e.loading ? e._l(i.skeletonNumber, function(n) {
    return t(i.LoadingTableRow, { key: n, attrs: { "show-checkbox": e.multiselect } });
  }) : e._l(i.sortedFiles, function(n) {
    return t(i.FileListRow, { key: n.fileid || n.path, attrs: { "allow-pick-directory": e.allowPickDirectory, "show-checkbox": e.multiselect, "can-pick": e.multiselect || e.selectedFiles.length === 0 || e.selectedFiles.includes(n), selected: e.selectedFiles.includes(n), node: n }, on: { "update:selected": function(s) {
      return i.onNodeSelected(n);
    }, "enter-directory": i.onChangeDirectory } });
  })], 2)])]);
}, st = [], rt = /* @__PURE__ */ p(
  nt,
  lt,
  st,
  !1,
  null,
  "c78369e2",
  null,
  null
);
const at = rt.exports, ot = {
  name: "HomeIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
var ct = function() {
  var e = this, t = e._self._c;
  return t("span", e._b({ staticClass: "material-design-icon home-icon", attrs: { "aria-hidden": !e.title, "aria-label": e.title, role: "img" }, on: { click: function(i) {
    return e.$emit("click", i);
  } } }, "span", e.$attrs, !1), [t("svg", { staticClass: "material-design-icon__svg", attrs: { fill: e.fillColor, width: e.size, height: e.size, viewBox: "0 0 24 24" } }, [t("path", { attrs: { d: "M10,20V14H14V20H19V12H22L12,3L2,12H5V20H10Z" } }, [e.title ? t("title", [e._v(e._s(e.title))]) : e._e()])])]);
}, ut = [], dt = /* @__PURE__ */ p(
  ot,
  ct,
  ut,
  !1,
  null,
  null,
  null,
  null
);
const _t = dt.exports, ft = {
  name: "PlusIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
var pt = function() {
  var e = this, t = e._self._c;
  return t("span", e._b({ staticClass: "material-design-icon plus-icon", attrs: { "aria-hidden": !e.title, "aria-label": e.title, role: "img" }, on: { click: function(i) {
    return e.$emit("click", i);
  } } }, "span", e.$attrs, !1), [t("svg", { staticClass: "material-design-icon__svg", attrs: { fill: e.fillColor, width: e.size, height: e.size, viewBox: "0 0 24 24" } }, [t("path", { attrs: { d: "M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z" } }, [e.title ? t("title", [e._v(e._s(e.title))]) : e._e()])])]);
}, mt = [], vt = /* @__PURE__ */ p(
  ft,
  pt,
  mt,
  !1,
  null,
  null,
  null,
  null
);
const ht = vt.exports, gt = /* @__PURE__ */ F({
  __name: "FilePickerBreadcrumbs",
  props: {
    path: null,
    showMenu: { type: Boolean }
  },
  emits: ["update:path", "create-node"],
  setup(l, { emit: e }) {
    const t = l, i = v(""), n = v();
    function s() {
      var a, h, _, k;
      const y = i.value.trim(), S = (h = (a = n.value) == null ? void 0 : a.$el) == null ? void 0 : h.querySelector("input");
      let w = "";
      return y.length === 0 ? w = d("File name cannot be empty.") : y.includes("/") ? w = d('"/" is not allowed inside a file name.') : ["..", "."].includes(y) ? w = d('"{name}" is an invalid file name.', { name: y }) : (_ = window.OC.config) != null && _.blacklist_files_regex && y.match((k = window.OC.config) == null ? void 0 : k.blacklist_files_regex) && (w = d('"{name}" is not an allowed filetype', { name: y })), S && S.setCustomValidity(w), w === "";
    }
    const c = function() {
      const a = i.value.trim();
      s() && (e("create-node", a), i.value = "");
    }, u = m(
      () => t.path.split("/").filter((a) => a !== "").map((a, h, _) => ({
        name: a,
        path: "/" + _.slice(0, h + 1).join("/")
      }))
    );
    return { __sfc: !0, props: t, emit: e, newNodeName: i, nameInput: n, validateInput: s, onSubmit: c, pathElements: u, IconFolder: V, IconHome: _t, IconPlus: ht, NcActions: le, NcActionInput: se, NcBreadcrumbs: re, NcBreadcrumb: ae, t: d };
  }
});
var yt = function() {
  var e = this, t = e._self._c, i = e._self._setupProxy;
  return t(i.NcBreadcrumbs, { staticClass: "file-picker__breadcrumbs", scopedSlots: e._u([{ key: "default", fn: function() {
    return [t(i.NcBreadcrumb, { attrs: { name: i.t("Home"), title: i.t("Home") }, on: { click: function(n) {
      return i.emit("update:path", "/");
    } }, scopedSlots: e._u([{ key: "icon", fn: function() {
      return [t(i.IconHome, { attrs: { size: 20 } })];
    }, proxy: !0 }]) }), e._l(i.pathElements, function(n) {
      return t(i.NcBreadcrumb, { key: n.path, attrs: { name: n.name, title: n.path }, on: { click: function(s) {
        return i.emit("update:path", n.path);
      } } });
    })];
  }, proxy: !0 }, e.showMenu ? { key: "actions", fn: function() {
    return [t(i.NcActions, { attrs: { "aria-label": i.t("Create directory"), "force-menu": !0, "force-title": !0, "menu-title": i.t("New"), type: "secondary" }, on: { close: function(n) {
      i.newNodeName = "";
    } }, scopedSlots: e._u([{ key: "icon", fn: function() {
      return [t(i.IconPlus, { attrs: { size: 20 } })];
    }, proxy: !0 }], null, !1, 2971667417) }, [t(i.NcActionInput, { ref: "nameInput", attrs: { value: i.newNodeName, label: i.t("New folder"), placeholder: i.t("New folder name") }, on: { "update:value": function(n) {
      i.newNodeName = n;
    }, submit: i.onSubmit, input: i.validateInput }, scopedSlots: e._u([{ key: "icon", fn: function() {
      return [t(i.IconFolder, { attrs: { size: 20 } })];
    }, proxy: !0 }], null, !1, 1614167509) })], 1)];
  }, proxy: !0 } : null], null, !0) });
}, wt = [], kt = /* @__PURE__ */ p(
  gt,
  yt,
  wt,
  !1,
  null,
  "f35f86d4",
  null,
  null
);
const Ct = kt.exports, bt = {
  name: "ClockIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
var Ft = function() {
  var e = this, t = e._self._c;
  return t("span", e._b({ staticClass: "material-design-icon clock-icon", attrs: { "aria-hidden": !e.title, "aria-label": e.title, role: "img" }, on: { click: function(i) {
    return e.$emit("click", i);
  } } }, "span", e.$attrs, !1), [t("svg", { staticClass: "material-design-icon__svg", attrs: { fill: e.fillColor, width: e.size, height: e.size, viewBox: "0 0 24 24" } }, [t("path", { attrs: { d: "M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M16.2,16.2L11,13V7H12.5V12.2L17,14.9L16.2,16.2Z" } }, [e.title ? t("title", [e._v(e._s(e.title))]) : e._e()])])]);
}, St = [], $t = /* @__PURE__ */ p(
  bt,
  Ft,
  St,
  !1,
  null,
  null,
  null,
  null
);
const xt = $t.exports, Nt = {
  name: "CloseIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
var Lt = function() {
  var e = this, t = e._self._c;
  return t("span", e._b({ staticClass: "material-design-icon close-icon", attrs: { "aria-hidden": !e.title, "aria-label": e.title, role: "img" }, on: { click: function(i) {
    return e.$emit("click", i);
  } } }, "span", e.$attrs, !1), [t("svg", { staticClass: "material-design-icon__svg", attrs: { fill: e.fillColor, width: e.size, height: e.size, viewBox: "0 0 24 24" } }, [t("path", { attrs: { d: "M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" } }, [e.title ? t("title", [e._v(e._s(e.title))]) : e._e()])])]);
}, Pt = [], zt = /* @__PURE__ */ p(
  Nt,
  Lt,
  Pt,
  !1,
  null,
  null,
  null,
  null
);
const Bt = zt.exports, It = {
  name: "MagnifyIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
var Rt = function() {
  var e = this, t = e._self._c;
  return t("span", e._b({ staticClass: "material-design-icon magnify-icon", attrs: { "aria-hidden": !e.title, "aria-label": e.title, role: "img" }, on: { click: function(i) {
    return e.$emit("click", i);
  } } }, "span", e.$attrs, !1), [t("svg", { staticClass: "material-design-icon__svg", attrs: { fill: e.fillColor, width: e.size, height: e.size, viewBox: "0 0 24 24" } }, [t("path", { attrs: { d: "M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z" } }, [e.title ? t("title", [e._v(e._s(e.title))]) : e._e()])])]);
}, Mt = [], Dt = /* @__PURE__ */ p(
  It,
  Rt,
  Mt,
  !1,
  null,
  null,
  null,
  null
);
const Vt = Dt.exports, Tt = {
  name: "StarIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
var Ht = function() {
  var e = this, t = e._self._c;
  return t("span", e._b({ staticClass: "material-design-icon star-icon", attrs: { "aria-hidden": !e.title, "aria-label": e.title, role: "img" }, on: { click: function(i) {
    return e.$emit("click", i);
  } } }, "span", e.$attrs, !1), [t("svg", { staticClass: "material-design-icon__svg", attrs: { fill: e.fillColor, width: e.size, height: e.size, viewBox: "0 0 24 24" } }, [t("path", { attrs: { d: "M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z" } }, [e.title ? t("title", [e._v(e._s(e.title))]) : e._e()])])]);
}, At = [], Et = /* @__PURE__ */ p(
  Tt,
  Ht,
  At,
  !1,
  null,
  null,
  null,
  null
);
const Ut = Et.exports, Ot = /* @__PURE__ */ F({
  __name: "FilePickerNavigation",
  props: {
    currentView: null,
    filterString: null,
    isCollapsed: { type: Boolean }
  },
  emits: ["update:currentView", "update:filterString"],
  setup(l, { emit: e }) {
    const t = l, i = [{
      id: "files",
      label: d("All files"),
      icon: V
    }, {
      id: "recent",
      label: d("Recent"),
      icon: xt
    }, {
      id: "favorites",
      label: d("Favorites"),
      icon: Ut
    }], n = m(() => i.filter((c) => c.id === t.currentView)[0]);
    return { __sfc: !0, allViews: i, props: t, emit: e, currentViewObject: n, updateFilterValue: (c) => e("update:filterString", c), IconClose: Bt, IconMagnify: Vt, NcButton: G, NcSelect: oe, NcTextField: ce, t: d, Fragment: fe };
  }
});
var Zt = function() {
  var e = this, t = e._self._c, i = e._self._setupProxy;
  return t(i.Fragment, [t(i.NcTextField, { staticClass: "file-picker__filter-input", attrs: { value: e.filterString, label: i.t("Filter file list"), "show-trailing-button": !!e.filterString }, on: { "update:value": i.updateFilterValue, "trailing-button-click": function(n) {
    return i.updateFilterValue("");
  } }, scopedSlots: e._u([{ key: "trailing-button-icon", fn: function() {
    return [t(i.IconClose, { attrs: { size: 16 } })];
  }, proxy: !0 }]) }, [t(i.IconMagnify, { attrs: { size: 16 } })], 1), e.isCollapsed ? t(i.NcSelect, { attrs: { "aria-label": i.t("Current view selector"), clearable: !1, searchable: !1, options: i.allViews, value: i.currentViewObject }, on: { input: (n) => i.emit("update:currentView", n.id) } }) : t("ul", { staticClass: "file-picker__side", attrs: { role: "tablist", "aria-label": i.t("Filepicker sections") } }, e._l(i.allViews, function(n) {
    return t("li", { key: n.id }, [t(i.NcButton, { attrs: { "aria-selected": e.currentView === n.id, type: e.currentView === n.id ? "primary" : "tertiary", wide: !0, role: "tab" }, on: { click: function(s) {
      return e.$emit("update:currentView", n.id);
    } }, scopedSlots: e._u([{ key: "icon", fn: function() {
      return [t(n.icon, { tag: "component", attrs: { size: 20 } })];
    }, proxy: !0 }], null, !0) }, [e._v(" " + e._s(n.label) + " ")])], 1);
  }), 0)], 1);
}, jt = [], Gt = /* @__PURE__ */ p(
  Ot,
  Zt,
  jt,
  !1,
  null,
  "fcfd0f23",
  null,
  null
);
const qt = Gt.exports;
/**
 * @copyright Copyright (c) 2023 Ferdinand Thiessen <opensource@fthiessen.de>
 *
 * @author Ferdinand Thiessen <opensource@fthiessen.de>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
const Kt = function(l, e) {
  const t = ee(_e("dav")), i = v([]), n = v(!0);
  async function s(u) {
    const a = await t.stat("".concat(z).concat(u), {
      details: !0
    });
    return P(a.data);
  }
  async function c() {
    if (n.value = !0, l.value === "favorites")
      i.value = await t.getDirectoryContents("".concat(z).concat(e.value), {
        details: !0,
        data: te(),
        headers: {
          method: "REPORT"
        },
        includeSelf: !1
      }).then((u) => u.data.map((a) => P(a)));
    else if (l.value === "recent") {
      const u = Math.round(Date.now() / 1e3) - 1209600, a = await t.getDirectoryContents(e.value, {
        details: !0,
        data: ie(u),
        headers: {
          method: "SEARCH",
          "Content-Type": "application/xml; charset=utf-8"
        },
        deep: !0
      });
      i.value = a.data.map((h) => P(h));
    } else {
      const u = await t.getDirectoryContents("".concat(z).concat(e.value), {
        details: !0,
        data: ne()
      });
      i.value = u.data.map((a) => P(a));
    }
    n.value = !1;
  }
  return O([l, e], () => c()), {
    isLoading: n,
    files: i,
    loadFiles: () => c(),
    getFile: s,
    client: t
  };
};
/**
 * @copyright Copyright (c) 2023 Ferdinand Thiessen <opensource@fthiessen.de>
 *
 * @author Ferdinand Thiessen <opensource@fthiessen.de>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
const Wt = function(l) {
  const e = m(() => l.value.map((i) => i.split("/")));
  return {
    isSupportedMimeType: (i) => {
      const n = i.split("/");
      return e.value.some(
        ([s, c]) => (
          // check mime type matches or is wildcard
          (n[0] === s || s === "*") && (n[1] === c || c === "*")
        )
      );
    }
  };
}, Jt = {
  name: "FilePicker"
}, Qt = /* @__PURE__ */ F({
  ...Jt,
  props: {
    buttons: null,
    name: null,
    allowPickDirectory: { type: Boolean, default: !1 },
    container: { default: "body" },
    filterFn: { default: void 0 },
    mimetypeFilter: { default: () => [] },
    multiselect: { type: Boolean, default: !0 },
    path: { default: "/" }
  },
  emits: ["close"],
  setup(l, { emit: e }) {
    const t = l, i = m(() => ({
      container: t.container,
      name: t.name,
      buttons: n.value,
      size: "large",
      contentClasses: ["file-picker__content"],
      dialogClasses: ["file-picker"],
      navigationClasses: ["file-picker__navigation"]
    })), n = m(() => (typeof t.buttons == "function" ? t.buttons(u.value, _.value, s.value) : t.buttons).map((r) => ({
      ...r,
      callback: async () => {
        const o = u.value.length === 0 && t.allowPickDirectory ? [await x(_.value)] : u.value;
        r.callback(o), e("close", u.value);
      }
    }))), s = v("files"), c = m(() => s.value === "favorites" ? d("Favorites") : s.value === "recent" ? d("Recent") : ""), u = v([]), a = v((window == null ? void 0 : window.sessionStorage.getItem("NC.FilePicker.LastPath")) || "/"), h = v(), _ = m({
      // Only use the path for the files view as favorites and recent only works on the root
      get: () => s.value === "files" ? h.value || t.path || a.value : "/",
      /**
       * Navigate to the new path and save it to the session storage
       *
       * @param path The new path
       */
      set: (f) => {
        t.path === void 0 && window.sessionStorage.setItem("NC.FilePicker.LastPath", f), h.value = f, u.value = [];
      }
    }), k = v(""), { isSupportedMimeType: y } = Wt(U(t, "mimetypeFilter")), { files: S, isLoading: w, loadFiles: C, getFile: x, client: N } = Kt(s, _);
    Z(() => C());
    const B = m(() => {
      let f = S.value;
      return t.mimetypeFilter.length > 0 && (f = f.filter((r) => r.type === "folder" || r.mime && y(r.mime))), k.value && (f = f.filter((r) => r.basename.toLowerCase().includes(k.value.toLowerCase()))), t.filterFn && (f = f.filter((r) => t.filterFn(r))), f;
    }), I = m(() => s.value === "files" ? d("Upload some content or sync with your devices!") : s.value === "recent" ? d("Files and folders you recently modified will show up here.") : d("Files and folders you mark as favorite will show up here."));
    return { __sfc: !0, props: t, emit: e, dialogProps: i, dialogButtons: n, currentView: s, viewHeadline: c, selectedFiles: u, savedPath: a, navigatedPath: h, currentPath: _, filterString: k, isSupportedMimeType: y, files: S, isLoading: w, loadFiles: C, getFile: x, client: N, filteredFiles: B, noFilesDescription: I, onCreateFolder: (f) => {
      N.createDirectory(q(z, _.value, f)).then(() => C()).catch((r) => pe(d("Could not create the new folder")));
    }, IconFile: K, DialogBase: X, FileList: at, FilePickerBreadcrumbs: Ct, FilePickerNavigation: qt, NcEmptyContent: ue, t: d };
  }
});
var Xt = function() {
  var e = this, t = e._self._c, i = e._self._setupProxy;
  return t(i.DialogBase, e._b({ on: { close: function(n) {
    return i.emit("close");
  } }, scopedSlots: e._u([{ key: "navigation", fn: function({ isCollapsed: n }) {
    return [t(i.FilePickerNavigation, { attrs: { "is-collapsed": n, "current-view": i.currentView, "filter-string": i.filterString }, on: { "update:currentView": function(s) {
      i.currentView = s;
    }, "update:current-view": function(s) {
      i.currentView = s;
    }, "update:filterString": function(s) {
      i.filterString = s;
    }, "update:filter-string": function(s) {
      i.filterString = s;
    } } })];
  } }]) }, "DialogBase", i.dialogProps, !1), [t("div", { staticClass: "file-picker__main" }, [i.currentView === "files" ? t(i.FilePickerBreadcrumbs, { attrs: { path: i.currentPath, "show-menu": e.allowPickDirectory }, on: { "update:path": function(n) {
    i.currentPath = n;
  }, "create-node": i.onCreateFolder } }) : t("div", { staticClass: "file-picker__view" }, [t("h3", [e._v(e._s(i.viewHeadline))])]), i.isLoading || i.filteredFiles.length > 0 ? t(i.FileList, { attrs: { "allow-pick-directory": e.allowPickDirectory, files: i.filteredFiles, multiselect: e.multiselect, loading: i.isLoading, path: i.currentPath, "selected-files": i.selectedFiles, name: i.viewHeadline }, on: { "update:path": [function(n) {
    i.currentPath = n;
  }, function(n) {
    i.currentView = "files";
  }], "update:selectedFiles": function(n) {
    i.selectedFiles = n;
  }, "update:selected-files": function(n) {
    i.selectedFiles = n;
  } } }) : i.filterString ? t(i.NcEmptyContent, { attrs: { name: i.t("No matching files"), description: i.t("No files matching your filter were found.") }, scopedSlots: e._u([{ key: "icon", fn: function() {
    return [t(i.IconFile)];
  }, proxy: !0 }]) }) : t(i.NcEmptyContent, { attrs: { name: i.t("No files in here"), description: i.noFilesDescription }, scopedSlots: e._u([{ key: "icon", fn: function() {
    return [t(i.IconFile)];
  }, proxy: !0 }]) })], 1)]);
}, Yt = [], ei = /* @__PURE__ */ p(
  Qt,
  Xt,
  Yt,
  !1,
  null,
  "dff32532",
  null,
  null
);
const _i = ei.exports;
export {
  _i as default
};
